import { useEffect } from "react";

const SITE_NAME = "The Motion Hub";
const DEFAULT_DESCRIPTION =
  "The Motion Hub is a curated library of the best motion design videos from brands and studios: explainers, product launches, ads, styleframes and scripts.";

function setMeta(selector: string, attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Keeps the tab title and share meta in sync during client-side navigation.
 * First-load meta for crawlers is injected server-side by the `seo` function.
 */
export function usePageMeta(title?: string, description?: string) {
  useEffect(() => {
    const fullTitle = title ? (title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`) : SITE_NAME;
    document.title = fullTitle;
    const desc = description?.trim() || DEFAULT_DESCRIPTION;
    setMeta('meta[name="description"]', "name", "description", desc);
    setMeta('meta[property="og:title"]', "property", "og:title", fullTitle);
    setMeta('meta[property="og:description"]', "property", "og:description", desc);
  }, [title, description]);
}
